// import * as common from '@/store/mutation-types';

export const SEARCH_PARAM = 'SEARCH_PARAM';
export const MESEQIPNO_LIST = 'MESEQIPNO_LIST';
export const PAGING_INFO = 'PAGING_INFO';
export const DEFAULT_ASSIGN = 'DEFAULT_ASSIGN';
export const STATE_INIT = 'STATE_INIT';

export default {
	// ...common,
	SEARCH_PARAM,
	MESEQIPNO_LIST,
	PAGING_INFO,
	DEFAULT_ASSIGN,
	STATE_INIT
};
